import {isProd} from './env';

export const warn = (msg, fn = 'error') => {
    !isProd && console[fn](`[科创中国]: ${msg}`);
}